module.exports = __webpack_public_path__ + "static/media/desktop.9bb8bdeb.svg";